/* Copyright (c) 2022 Xperi. All Rights Reserved. */

export const START_ENTER_CHANNEL_NUMBER = 'START_ENTER_CHANNEL_NUMBER';
export const STOP_ENTER_CHANNEL_NUMBER = 'STOP_ENTER_CHANNEL_NUMBER';
export const GUIDE_SET_ENTERED_CHANNEL_NUMBER = 'GUIDE_SET_ENTERED_CHANNEL_NUMBER';
